import { trackUnscopedButtonClicked } from '@/app-shell/ui/tracked-button-click';
import {
  trackDictateReengagementViewed,
  useDictateReengagementViewExposure,
} from '@/models/analytics/features/dictate-reengagement-analytics';
import { dictationLogsAnalyticsPorts } from '@/models/analytics/features/trackDictationLogsAnalytics';
import { configureDictationAnalyticsPorts } from '@heidi/dictate';

const tauriDictationAnalytics = {
  ui: { trackUnscopedButtonClicked },
  logs: dictationLogsAnalyticsPorts,
  reengagement: {
    trackViewed: trackDictateReengagementViewed,
    useViewExposure: useDictateReengagementViewExposure,
  },
};

configureDictationAnalyticsPorts(tauriDictationAnalytics);

export { tauriDictationAnalytics };
